import { z } from 'zod';
/** Wire enums aligned with `specs/348-generation-gate-evaluator/contracts/generation-gate-evaluation.openapi.yaml`. */
export const generationGateOutcomeSchema = z.enum([
    'eligible_preflight',
    'not_eligible_skip',
    'not_eligible_pending',
]);
export const generationGateReasonFamilySchema = z.enum([
    'eligible',
    'scope_ineligible',
    'project_not_allowlisted',
    'issue_type_not_allowlisted',
    'status_denied',
    'input_quality_insufficient',
    'readiness_trigger_missing',
    'policy_binding_invalid',
    'snapshot_incomplete',
]);
export const generationGateIssueSnapshotSchema = z
    .object({
    organization_id: z.string().uuid(),
    project_key: z.string().max(128),
    issue_type_key: z.string().max(128),
    status_key: z.string().max(128).nullable().optional(),
    description_metrics: z
        .object({
        length: z.number().int().min(0),
    })
        .strict(),
    readiness_signals: z.record(z.unknown()),
    scope_context: z.record(z.unknown()).optional(),
})
    .strict();
export const generationGateProviderKindSchema = z.enum(['jira', 'linear', 'azure_boards']);
export const generationGateAllowlistModeSchema = z.enum(['selected', 'all']);
export const generationGatePolicyBindingSchema = z
    .object({
    organization_id: z.string().uuid(),
    provider_kind: generationGateProviderKindSchema.optional(),
    policy_version: z.string().max(128),
    scope: z.record(z.unknown()),
    project_allowlist_mode: generationGateAllowlistModeSchema.optional(),
    project_allowlist: z.array(z.string().max(128)).max(512),
    issue_type_allowlist_mode: generationGateAllowlistModeSchema.optional(),
    issue_type_allowlist: z.array(z.string().max(128)).max(512),
    status_denylist: z.array(z.string().max(128)).max(256),
    min_description_length: z.number().int().min(0),
    readiness_trigger: z.record(z.unknown()),
})
    .strict()
    .superRefine((binding, ctx) => {
    const projectMode = binding.project_allowlist_mode ?? 'selected';
    if (projectMode === 'selected' && binding.project_allowlist.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'project_allowlist must not be empty when project_allowlist_mode is selected',
            path: ['project_allowlist'],
        });
    }
    const issueTypeMode = binding.issue_type_allowlist_mode ?? 'selected';
    if (issueTypeMode === 'selected' && binding.issue_type_allowlist.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'issue_type_allowlist must not be empty when issue_type_allowlist_mode is selected',
            path: ['issue_type_allowlist'],
        });
    }
});
export const generationGatePolicyPutRequestSchema = z
    .object({
    provider_kind: generationGateProviderKindSchema,
    expected_policy_version: z.number().int().min(0),
    binding: generationGatePolicyBindingSchema,
})
    .strict()
    .superRefine((request, ctx) => {
    if (request.binding.provider_kind && request.binding.provider_kind !== request.provider_kind) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'binding.provider_kind must match provider_kind',
            path: ['binding', 'provider_kind'],
        });
    }
});
export const generationGatePolicyPreviewRequestSchema = z
    .object({
    provider_kind: generationGateProviderKindSchema,
    binding: generationGatePolicyBindingSchema.optional(),
    sample_issue: generationGateIssueSnapshotSchema,
})
    .strict();
export const generationGateEvaluationResultSchema = z
    .object({
    outcome: generationGateOutcomeSchema,
    primary_reason_family: generationGateReasonFamilySchema,
    secondary_reason_families: z.array(generationGateReasonFamilySchema).max(8).optional(),
    policy_version: z.string().max(128).nullable(),
    evaluated_at: z.string().datetime({ offset: true }),
})
    .strict();
//# sourceMappingURL=generation-gate-policy.schema.js.map